<template src="./building.html"></template>

<script>
    /* eslint-disable no-console,object-shorthand,func-names,new-parens */
    import { mapGetters } from 'vuex';
    import {
        ADD_BUILDING,
        ADD_FIELD,
        DELETE_FIELD, DOWNLOAD_PANEL_PRICES,
        FETCH_BUILDING, FETCH_BUILDINGS, FETCH_SUPPLIERS,
        UPDATE_BUILDING,
        UPLOAD_PANEL_PRICE,
        UPLOAD_PANEL_PRICE_SINGLE,
        DELETE_PANEL_PRICE_SINGLE,
    } from '../../../store/types';
    import FieldForm from '../fields/FieldForm';
    import Breadcrumb from '../../atoms/breadcrumb/Breadcrumb';
    import DeleteDialog from '../../atoms/dialog/Delete';
    import DeleteBtn from '../../atoms/button/DeleteBtn';
    import api from '../../../util/api';

    export default {
        name: 'Sectors',
        components: { FieldForm, Breadcrumb, DeleteDialog, DeleteBtn },
        data () {
            return {
                loading: false,
                showFieldForm: false,
                editMode: false,
                priceEditMode: false,
                createMode: false,
                deleteMode: false,
                deleteField: null,
                formSubmitted: false,
                priceFile: null,
                newPanelPrice: '',
                newPanelDate: '',
                buildingImageFile: null,
                buildingImageFileList: [],
                building: {
                    supplier: null,
                    default_panel_price: null,
                    prices: [],
                },
                rules: {
                    supplier: [
                        { required: true, message: 'Supplier fehlt', trigger: 'change' },
                    ],
                    street: [
                        { required: true, message: 'Strasse fehlt', trigger: 'blur' },
                    ],
                    house_number: [
                        { required: true, message: 'Nummer fehlt', trigger: 'blur' },
                    ],
                    default_panel_price: [
                        { required: true, message: 'Preis fehlt', trigger: 'blur' },
                    ],
                    building_width: [
                        { required: true, message: 'Gebäudehöhe fehlt', trigger: 'blur' },
                    ],
                    fields_top_position: [
                        { required: true, message: 'Oberste Position fehlt', trigger: 'blur' },
                    ],
                    fields_left_position: [
                        { required: true, message: 'Linke Position fehlt', trigger: 'blur' },
                    ],
                    field_width: [
                        { required: true, message: 'Feldhöhe fehlt', trigger: 'blur' },
                    ],
                    image: [
                        { required: true, message: 'Bild fehlt', trigger: 'blur' },
                    ],
                },
            };
        },
        computed: {
            ...mapGetters(['get_buildings', 'get_building', 'get_suppliers', 'user_is_admin', 'get_current_user', 'get_field']),
            hasDefaultPrice () {
                return this.building && this.building.default_panel_price != null;
            },
            noPrices () {
                if (this.building.prices.length > 0) {
                    if (this.building.prices.length === 1) {
                        if (!this.building.prices[0].id) {
                            return true;
                        }
                    }
                    return !this.building.prices;
                }
                    return true;
            },
        },
        created () {
            const routeParams = this.$route.params;

            if (this.$route.name === 'new-building') {
                this.loading = true;
                this.$store.dispatch(FETCH_SUPPLIERS).then(() => {
                    this.createMode = true;
                    if (!this.get_buildings) {
                        this.$store.dispatch(FETCH_BUILDINGS);
                    }

                    this.$watch('createMode', (isCreateMode) => {
                        if (!isCreateMode && !this.editMode) {
                            this.$router.push('/buildings');
                        }
                    });
                }).finally(() => {
                    this.loading = false;
                });
            } else {
                this.loading = true;

                this.setBuildingData(routeParams.buildingId).then(() => {
                    this.$store.dispatch(FETCH_SUPPLIERS).then(() => {
                        this.loading = false;
                    });
                });
            }
        },
        methods: {
            handleEditRow (index) {
                if (typeof this.building.prices[index].edited === 'undefined') {
                    this.$set(this.building.prices[index], 'edited', true);
                } else if (this.building.prices[index].edited === true) {
                    this.building.prices[index].edited = false;
                } else {
                    this.building.prices[index].edited = true;
                }
            },
            handleSaveRow (index, row) {
                if (this.uploadPriceSingle(row, index)) {
                    this.building.prices[index].edited = false;
                }
            },
            handleDeleteRow (index, row) {
                this.deletePriceSingle(index, row);
            },
            clearNewPanel () {
                this.newPanelPrice = '';
                this.newPanelDate = '';
            },
            setBuildingData (buildingId) {
                return new Promise((resolve) => {
                    // have to fetch to check the price according current date
                    this.$store.dispatch(FETCH_BUILDING, buildingId).then((resp) => {
                        // this.building = this.get_building(this.$route.params.buildingId);
                        this.$store.commit(UPDATE_BUILDING, resp);
                        this.building = resp;
                        this.building.default_panel_price = resp.default_panel_price;

                        if (resp.image) {
                            this.buildingImageFileList.push({ url: resp.image });
                            this.buildingImageFile = resp.image_url;
                        } else {
                            this.buildingImageFileList = [];
                        }

                        resolve();
                    });
                });
            },
            getPanelTagType (panelStatus) {
                let type = '';
                switch (panelStatus) {
                    case 'available':
                        type = 'success';
                        break;
                    case 'reserved':
                        type = 'warning';
                        break;
                    default:
                        type = 'danger';
                }

                return type;
            },
            priceUploadChangeHandler (request) {
                this.priceFile = request.raw;
                this.$refs.upload.submit();
            },
            onChangeBuildingImage (request, fileList) {
                this.buildingImageFileList = fileList.slice(-1);
                this.buildingImageFile = request.raw;
                this.building.image = request.raw;
            },
            onRemoveBuildingImage () {
                this.buildingImageFileList = [];
                this.buildingImageFile = null;
                this.building.image = null;
            },
            getUploadPriceUrl () {
                return `${api.getBaseUrl()}/building/${this.building.id}/panel-price`;
            },
            uploadPrice () {
                if (this.building.id) {
                    const data = new FormData();
                    data.append('prices', this.priceFile);
                    const buildingId = this.building.id;

                    this.$store.dispatch(UPLOAD_PANEL_PRICE, { buildingId, data })
                        .then((resp) => {
                            this.building = resp.data;
                            document.querySelectorAll('.red').forEach(
                                (e) => {
                                    e.classList.remove('red');
                                    });
                            if (this.priceEditMode) {
                                this.$message.success(resp.message);
                                this.priceEditMode = false;
                            } else {
                                this.showFieldForm = true;
                            }
                        });
                }
            },
            // eslint-disable-next-line no-unused-vars
            uploadPriceSingle (panel, index) {
                this.loading = true;
                if (this.building.id) {
                    const buildingId = this.building.id;
                    const data = {
                        buildingId,
                        id: panel.id,
                        price_start_date: panel.price_start_date,
                        price: panel.price,
                    };

                    this.$store.dispatch(UPLOAD_PANEL_PRICE_SINGLE, data)
                        .then((resp) => {
                            this.loading = false;
                            this.building = resp.data;
                            if (document.querySelector(`#panel_${panel.id}`)) {
                                document.querySelector(`#panel_${panel.id}`).classList.remove('red');
                                document.querySelector(`#panel_price_${panel.id}`).classList.remove('red');
                            }
                            return true;
                        })
                        .catch((err) => {
                            console.log(err);
                            console.log(data);
                            if (document.querySelector(`#panel_${panel.id}`)) {
                            document.querySelector(`#panel_${data.id}`).classList.add('red');
                            document.querySelector(`#panel_price_${data.id}`).classList.add('red');
                            }
                            this.loading = false;
                            return false;
                        });
                }
            },
            uploadPriceSingleNew (panel) {
                this.loading = true;
                if (this.building.id) {
                    const buildingId = this.building.id;
                    const data = {
                        buildingId,
                        id: panel.id,
                        price_start_date: panel.price_start_date,
                        price: panel.price,
                    };

                    this.$store.dispatch(UPLOAD_PANEL_PRICE_SINGLE, data)
                        .then((resp) => {
                            this.loading = false;
                            this.building = resp.data;
                            document.querySelector('#new_panel_date').classList.remove('red');
                            document.querySelector('#new_panel_price').classList.remove('red');
                            return true;
                        })
                        .catch((err) => {
                            console.log(err);
                            console.log(data);
                            document.querySelector('#new_panel_date').classList.add('red');
                            document.querySelector('#new_panel_price').classList.add('red');
                            this.loading = false;
                            return false;
                        });
                }
            },
            deletePriceSingle (index, panel) {
                this.loading = true;
                if (this.building.id) {
                    const buildingId = this.building.id;
                    const data = {
                        buildingId,
                        id: panel.id,
                    };

                    this.$store.dispatch(DELETE_PANEL_PRICE_SINGLE, data)
                        .then((resp) => {
                            this.loading = false;
                            this.building = resp.data;
                            document.getElementById(`panel_${panel.id}`).classList.remove('red');
                            document.getElementById(`panel_price_${panel.id}`).classList.remove('red');
                            return true;
                        })
                        .catch((err) => {
                            console.log(err);
                            document.getElementById(`panel_${panel.id}`).classList.add('red');
                            document.getElementById(`panel_price_${panel.id}`).classList.add('red');
                            this.loading = false;
                            return false;
                        });
                }
            },
            downloadPanelPrices () {
                this.$store.dispatch(DOWNLOAD_PANEL_PRICES, this.building.id);
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.formSubmitted = true;
                        const postData = this.getPostData();

                        const responseCallback = (resp) => {
                            this.building = Object.assign({}, resp.data);
                            this.formSubmitted = false;
                            this.editMode = false;

                            this.buildingImageFileList = [];
                            if (resp.data.image) {
                                this.buildingImageFileList.push({ url: resp.data.image });
                            }

                            this.$message.success(resp.message);
                        };

                        if (this.createMode) {
                            this.editMode = true;
                            this.createMode = false;
                            this.$store.dispatch(ADD_BUILDING, postData).then((resp) => {
                                responseCallback(resp);
                            });
                        } else {
                            postData.id = this.building.id;
                            this.$store.dispatch(UPDATE_BUILDING, postData).then((resp) => {
                                responseCallback(resp);
                            });
                        }
                    }
                });
            },
            cancelForm () {
                if (this.createMode) {
                    this.createMode = false;
                }

                if (this.editMode) {
                    this.editMode = false;
                }
            },
            fieldSubmitFormCallback (responseData) {
                const field = responseData.data;
                const building = field.building;
                this.$store.commit(ADD_FIELD, { field, building });
            },
            deleteClickHandler (field) {
                this.deleteMode = true;
                this.deleteField = field;
            },
            deleteConfirmCallback () {
                const field = this.deleteField;
                const building = this.get_building(field.building_id);
                this.$store.dispatch(DELETE_FIELD, { field, building }).then((resp) => {
                    this.deleteMode = false;
                    this.$message.success(resp.message);
                });
            },
            getPostData () {
                const postData = {
                    street: this.building.street,
                    house_number: this.building.house_number,
                    suffix: this.building.suffix || null,
                    fields_top_position: this.building.fields_top_position,
                    fields_left_position: this.building.fields_left_position,
                    field_width: this.building.field_width,
                    building_width: this.building.building_width,
                    default_panel_price: this.building.default_panel_price,
                    image: this.buildingImageFile,
                    building_step1_text: this.building.building_step1_text || null,
                    building_order_mail_body: this.building.building_order_mail_body || null,
                    building_order_gift_mail_body: this.building.building_order_gift_mail_body || null,
                };

                if (this.user_is_admin) {
                    postData.supplier_id = this.building.supplier.id;
                } else {
                    postData.supplier_id = this.get_current_user.supplier_id;
                }

                const formData = new FormData();
                Object.keys(postData).forEach((key) => {
                    if (postData[key] !== null && postData[key] !== 'undefined') {
                        formData.append(key, postData[key]);
                    }
                });
                return formData;
            },
        },
    };
</script>
<style>

    .bold{
        font-weight: bold !important;
    }

    .bold input[disabled]{
        font-weight: bold !important;
        color: rgb(88, 88, 88) !important;
    }

    .red{
        color: red !important;
    }
    </style>

<style lang="scss" scoped>

    .el-select {
        width: 100%;
    }
    .el-card {
        margin-bottom: 2rem;

        .el-col {
            p {
                &.title {
                    font-size: 16px;
                }
                font-size: 14px;

                &::after {
                    content: '';
                    width: 5px;
                    height: 5px;
                    display: inline-block;
                    border-radius: 50%;
                }
                &.available::after {
                    background-color: rgb(103,194,58);
                }
                &.reserved::after {
                    background-color: rgb(230,162,60);
                }
                &.taken::after {
                    background-color: rgb(245,108,108);
                }
            }
        }

        .code-highlight {
            font-family:'Courier New', Courier, monospace;
            word-wrap: normal;
            color: #111;

            &.inline {
                display: inline;
                font-weight: 600;
            }

            &.box {
                border: 1px solid #ccc;
                border-radius: 3px;
                padding: 8px;
                font-weight: 400;
                font-size: .92em;
            }
        }
    }
    .border-bottom {
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid #0000001a;
    }
    .field-box {
        margin-bottom: 1rem;
        height: 200px;
        p { font-size: 14px; }
    }
    .building-details {
        position: relative;

        .building-details--image {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            img {
                position: relative;
                height: 100%;
            }
        }
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/buildings/Building.vue